import { Icon24Voice } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

export const AudioWaveformIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <rect x="8" y="20" width="3" height="12" rx="1.5" fill="currentColor" />
      <rect x="14" y="15" width="3" height="22" rx="1.5" fill="currentColor" />
      <rect x="20" y="10" width="3" height="32" rx="1.5" fill="currentColor" />
      <rect x="26" y="17" width="3" height="18" rx="1.5" fill="currentColor" />
      <rect x="32" y="7" width="3" height="38" rx="1.5" fill="currentColor" />
      <rect x="38" y="14" width="3" height="24" rx="1.5" fill="currentColor" />
      <rect x="44" y="21" width="3" height="10" rx="1.5" fill="currentColor" />
    </svg>
  );
};

export const AudioWaveformIcon = fplIcon(AudioWaveformIconLocal, Icon24Voice);
